<app-kpi-widget
  [title]="'executiveStats.widgets.fuelVariance' | transloco"
  [isLoading]="isLoading"
  icon="ph-truck"
  [totalValue]="value"
  [totalCost]="cost"
  [costDifference]="difference"
  [percentageDifference]="percentageDifference"
  [dropdownOptions]="dropdownOptions"
  [isUptrendPositive]="isUptrendPositive"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [costDifferenceFormatter]="formatVarianceDifference.bind(this)"
  [dropdownEnabled]="false"
  [hasCost]="false"
  [isImageIcon]="false"
></app-kpi-widget>